module.exports = __webpack_public_path__ + "img/ill_badge_request_cod.d7bd042f.svg";